export const canAccessPaymentInvoices = userData =>
  userData?.email_validated === true;
